var base = require('settings/subscription/resume-subscription');

Vue.component('spark-resume-subscription', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/subscription/resume-subscription.js